<template>
  <div class="hero">
  <swiper
    :modules="modules"
    :slides-per-view="1"
    :loop="true"
    :speed="600"
    :autoplay="{
      delay: 4000,
      disableOnInteraction: false,
    }"
    class="hero-swiper"
    @swiper="onSwiper"
  >
    <swiper-slide v-for="(slide, index) in slides" :key="index">
      <div class="slide">
        <picture class="slide-picture">
          <source media="(max-width: 767px)" :srcset="slide.img375" />
          <source media="(max-width: 1023px)" :srcset="slide.img768" />
          <source media="(max-width: 1279px)" :srcset="slide.img1024" />
          <source media="(max-width: 1439px)" :srcset="slide.img1280" />
          <source media="(max-width: 1919px)" :srcset="slide.img1440" />
          <img
            class="slide-image"
            :class="{ 'slide-image-top': index === 4 }"
            :src="slide.img1920"
            :alt="$t('homeNew.hero.slides.' + index + '.line1')"
            @load="updateSlide5Position"
          />
        </picture>
        <div class="slide-text">
          <div class="slide-text-inner">
            <div class="slide-line1">{{ $t('homeNew.hero.slides.' + index + '.line1') }}</div>
            <div class="slide-line2">{{ $t('homeNew.hero.slides.' + index + '.line2') }}</div>
            <div class="slide-line3">{{ $t('homeNew.hero.slides.' + index + '.line3') }}</div>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper>
  <PromoBanner />
  </div>
</template>

<script>
import hero1_375 from '@/assets/img/main-hero/hero_1_375.jpg';
import hero1_768 from '@/assets/img/main-hero/hero_1_768.jpg';
import hero1_1024 from '@/assets/img/main-hero/hero_1_1024.jpg';
import hero1_1280 from '@/assets/img/main-hero/hero_1_1280.jpg';
import hero1_1440 from '@/assets/img/main-hero/hero_1_1440.jpg';
import hero1_1920 from '@/assets/img/main-hero/hero_1_1920.jpg';

import hero2_375 from '@/assets/img/main-hero/hero_2_375.jpg';
import hero2_768 from '@/assets/img/main-hero/hero_2_768.jpg';
import hero2_1024 from '@/assets/img/main-hero/hero_2_1024.jpg';
import hero2_1280 from '@/assets/img/main-hero/hero_2_1280.jpg';
import hero2_1440 from '@/assets/img/main-hero/hero_2_1440.jpg';
import hero2_1920 from '@/assets/img/main-hero/hero_2_1920.jpg';

import hero3_375 from '@/assets/img/main-hero/hero_3_375.jpg';
import hero3_768 from '@/assets/img/main-hero/hero_3_768.jpg';
import hero3_1024 from '@/assets/img/main-hero/hero_3_1024.jpg';
import hero3_1280 from '@/assets/img/main-hero/hero_3_1280.jpg';
import hero3_1440 from '@/assets/img/main-hero/hero_3_1440.jpg';
import hero3_1920 from '@/assets/img/main-hero/hero_3_1920.jpg';

import hero4_375 from '@/assets/img/main-hero/hero_4_375.jpg';
import hero4_768 from '@/assets/img/main-hero/hero_4_768.jpg';
import hero4_1024 from '@/assets/img/main-hero/hero_4_1024.jpg';
import hero4_1280 from '@/assets/img/main-hero/hero_4_1280.jpg';
import hero4_1440 from '@/assets/img/main-hero/hero_4_1440.jpg';
import hero4_1920 from '@/assets/img/main-hero/hero_4_1920.jpg';

import hero5_375 from '@/assets/img/main-hero/hero_5_375.jpg';
import hero5_768 from '@/assets/img/main-hero/hero_5_768.jpg';
import hero5_1024 from '@/assets/img/main-hero/hero_5_1024.jpg';
import hero5_1280 from '@/assets/img/main-hero/hero_5_1280.jpg';
import hero5_1440 from '@/assets/img/main-hero/hero_5_1440.jpg';
import hero5_1920 from '@/assets/img/main-hero/hero_5_1920.jpg';

import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import PromoBanner from '@/components/main/PromoBanner';

import 'swiper/css';

export default {
  name: 'MainHeroSlider',
  components: {
    Swiper,
    SwiperSlide,
    PromoBanner,
  },
  setup() {
    return {
      modules: [Autoplay],
    };
  },
  data() {
    return {
      slides: [
        {
          img375: hero1_375,
          img768: hero1_768,
          img1024: hero1_1024,
          img1280: hero1_1280,
          img1440: hero1_1440,
          img1920: hero1_1920,
        },
        {
          img375: hero2_375,
          img768: hero2_768,
          img1024: hero2_1024,
          img1280: hero2_1280,
          img1440: hero2_1440,
          img1920: hero2_1920,
        },
        {
          img375: hero3_375,
          img768: hero3_768,
          img1024: hero3_1024,
          img1280: hero3_1280,
          img1440: hero3_1440,
          img1920: hero3_1920,
        },
        {
          img375: hero4_375,
          img768: hero4_768,
          img1024: hero4_1024,
          img1280: hero4_1280,
          img1440: hero4_1440,
          img1920: hero4_1920,
        },
        {
          img375: hero5_375,
          img768: hero5_768,
          img1024: hero5_1024,
          img1280: hero5_1280,
          img1440: hero5_1440,
          img1920: hero5_1920,
        },
      ],
    };
  },
  mounted() {
    this.updateSlide5Position();
    window.addEventListener('resize', this.updateSlide5Position);
  },
  unmounted() {
    window.removeEventListener('resize', this.updateSlide5Position);
  },
  methods: {
    onSwiper() {
      this.$nextTick(() => {
        this.updateSlide5Position();
      });
    },
    updateSlide5Position() {
      const images = this.$el?.querySelectorAll('.slide-image-top');
      if (!images?.length) {
        return;
      }

      images.forEach((img) => {
        if (!img.naturalWidth || !img.naturalHeight) {
          return;
        }

        const boxW = img.clientWidth;
        const boxH = img.clientHeight;
        if (!boxW || !boxH) {
          return;
        }

        const scale = Math.max(boxW / img.naturalWidth, boxH / img.naturalHeight);
        const overflow = img.naturalHeight * scale - boxH;
        if (overflow <= 0) {
          img.style.objectPosition = 'center';
          return;
        }

        const cropTop = Math.min(overflow / 2, 80);
        img.style.objectPosition = `center ${(cropTop / overflow) * 100}%`;
      });
    },
  },
};
</script>

<style scoped>
.hero {
  position: relative;
  width: 100%;
}

.hero-swiper {
  width: 100%;
  height: 140vw;
}

@media screen and (min-width: 580px) {
  .hero-swiper {
    height: 120vw;
  }
}

@media screen and (min-width: 768px) {
  .hero-swiper {
    height: 70vw;
  }
}

@media screen and (min-width: 1180px) {
  .hero-swiper {
    height: calc(100vh - 192px);
  }
}

.slide {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.slide-picture {
  display: block;
  width: 100%;
  height: 100%;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.slide-text {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 40px 16px 0;
  color: white;
  text-align: left;
  box-sizing: border-box;
}

.slide-text-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .slide-text {
    width: 50%;
    justify-content: center;
    padding: 0 40px 126px;
  }

  .slide-text-inner {
    max-width: 600px;
  }
}

@media screen and (min-width: 1024px) {
  .slide-text-inner {
    gap: 20px;
  }
}

@media screen and (min-width: 1440px) {
  .slide-text {
    padding: 0 80px 116px;
  }
}

@media screen and (min-width: 1920px) {
  .slide-text {
    padding: 0 120px 126px;
  }

  .slide-text-inner {
    max-width: 720px;
  }
}

.slide-line1 {
  white-space: pre-line;
  line-height: 1.2;
  text-transform: uppercase;
  font-weight: 700;
}

.slide-line2 {
  white-space: pre-line;
  line-height: 1;
  text-transform: uppercase;
  font-weight: 700;
}

.slide-line3 {
  white-space: pre-line;
  line-height: 1.2;
  font-weight: 400;
}

.slide-line1 {
  font-size: 20px;
}

.slide-line2 {
  font-size: 32px;
}

.slide-line3 {
  font-size: 18px;
}

@media screen and (min-width: 768px) {
  .slide-line1 {
    font-size: 22px;
  }

  .slide-line2 {
    font-size: 36px;
  }
}

@media screen and (min-width: 1024px) {
  .slide-line1 {
    font-size: 28px;
  }

  .slide-line2 {
    font-size: 60px;
  }
}

@media screen and (min-width: 1920px) {
  .slide-line1 {
    font-size: 32px;
  }

  .slide-line2 {
    font-size: 66px;
  }

  .slide-line3 {
    font-size: 22px;
  }
}
</style>
